// extracted by mini-css-extract-plugin
module.exports = {"arrow_button":"a10a3f92e9--arrow_button--3cCRY","arrow_button--left":"a10a3f92e9--arrow_button--left--1KiiT"};